import React from 'react';
import { Leaf, Mail, MapPin, Phone } from './Icons';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="relative z-10 mt-16 border-t border-white/10">
      <div className="mx-auto max-w-6xl px-4 py-10">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <div className="rounded-full bg-emerald-500/15 p-2">
                <Leaf className="h-5 w-5" />
              </div>
              <div className="font-semibold tracking-tight">Praash Green Energy</div>
            </div>
            <p className="mt-3 text-sm text-white/70">
              We develop, build, own, and operate renewable infrastructure — starting with solar and expanding into storage and hybrids.
            </p>
          </div>

          <div className="text-sm">
            <div className="font-semibold">Contact</div>
            <div className="mt-3 space-y-2 text-white/70">
              <div className="flex items-center gap-2"><Mail className="h-4 w-4" /> praashgreenenergy@gmail.com</div>
              <div className="flex items-center gap-2"><MapPin className="h-4 w-4" /> Pune, Maharashtra</div>
            </div>
          </div>

          <div className="text-sm">
            <div className="font-semibold">Quick links</div>
            <div className="mt-3 grid grid-cols-2 gap-2 text-white/70">
              <a className="hover:text-white" href="/">Home</a>
              <a className="hover:text-white" href="/about">About</a>
              <a className="hover:text-white" href="/solar-parks">Projects</a>
              <a className="hover:text-white" href="/contact">Contact</a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 md:flex-row md:items-center">
          <div className="text-xs text-white/60">© {year} Praash Green Energy. All rights reserved.</div>
          <div className="text-xs text-white/60">Built with renewable first design principles.</div>
        </div>
      </div>
    </footer>
  );
}
